/* Nomination header / mobil menü / arama / dil seçici - Veritas Dijital */
(function () {
  'use strict';

  /* ---------- Dil / ülke seçici (header, drawer, footer) ---------- */
  function closeAllXb(except) {
    document.querySelectorAll('[data-nm-xb]').forEach(function (item) {
      if (item === except) return;
      var btn = item.querySelector('[data-nm-xb-toggle]');
      var list = item.querySelector('.nm-xb__list');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (list) list.hidden = true;
    });
  }

  if (!window.__nmXbBound) {
    window.__nmXbBound = true;
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-nm-xb-toggle]');
      if (toggle) {
        var item = toggle.closest('[data-nm-xb]');
        var list = item.querySelector('.nm-xb__list');
        var open = toggle.getAttribute('aria-expanded') === 'true';
        closeAllXb(item);
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        list.hidden = open;
        return;
      }
      var option = e.target.closest('.nm-xb__option');
      if (option) {
        e.preventDefault();
        var form = option.closest('form');
        var input = form.querySelector('input[name="' + option.dataset.input + '"]');
        if (input) input.value = option.dataset.value;
        form.submit();
        return;
      }
      if (!e.target.closest('[data-nm-xb]')) closeAllXb();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllXb();
    });
  }

  if (customElements.get('nm-header')) return;

  class NmHeader extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('#NmSearch');
      this.drawer = this.querySelector('#NmDrawer');
      this.bindNav();
      this.bindSearch();
      this.bindDrawer();
      this.setHeightVar();
      window.addEventListener('resize', this.setHeightVar.bind(this));
      window.addEventListener('load', this.setHeightVar.bind(this));
    }

    setHeightVar() {
      var root = document.documentElement;
      var lower = this.querySelector('.nm-header__row--lower');
      var collapse = 0;
      if (window.matchMedia('(min-width: 960px)').matches && lower) {
        collapse = lower.offsetTop;
      }
      var section = this.closest('.shopify-section');
      if (section) section.style.setProperty('--nm-header-collapse', collapse + 'px');
      root.style.setProperty('--nm-header-height', (this.offsetHeight - collapse) + 'px');
      var rect = this.getBoundingClientRect();
      root.style.setProperty('--nm-drawer-top', Math.max(0, rect.bottom) + 'px');
    }

    /* ----- Masaüstü menü (hover + klavye) ----- */
    bindNav() {
      var items = this.querySelectorAll('.nm-nav [data-nm-nav-item]');
      items.forEach(function (item) {
        var link = item.querySelector(':scope > .nm-nav__link');
        var timer;
        var open = function () {
          clearTimeout(timer);
          items.forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              other.querySelector(':scope > .nm-nav__link').setAttribute('aria-expanded', 'false');
            }
          });
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        };
        var close = function () {
          timer = setTimeout(function () {
            item.classList.remove('is-open');
            link.setAttribute('aria-expanded', 'false');
          }, 120);
        };
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) close();
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            item.classList.remove('is-open');
            link.setAttribute('aria-expanded', 'false');
            link.focus();
          }
        });
      });
    }

    /* ----- Arama paneli ----- */
    bindSearch() {
      var self = this;
      this.searchButtons = this.querySelectorAll('[data-nm-search-toggle]');
      this.searchButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.search.hidden ? self.openSearch() : self.closeSearch();
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.search.hidden) self.closeSearch();
      });
      document.addEventListener('click', function (e) {
        if (self.search.hidden) return;
        if (e.target.closest('#NmSearch') || e.target.closest('[data-nm-search-toggle]')) return;
        self.closeSearch();
      });
    }

    openSearch() {
      this.search.hidden = false;
      this.classList.add('is-search-open');
      this.searchButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var input = this.search.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }

    closeSearch() {
      this.search.hidden = true;
      this.classList.remove('is-search-open');
      this.searchButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }

    /* ----- Mobil menü ----- */
    bindDrawer() {
      var self = this;
      this.querySelectorAll('[data-nm-drawer-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.drawer.classList.contains('is-open') ? self.closeDrawer() : self.openDrawer(btn);
        });
      });
      this.drawer.querySelectorAll('[data-nm-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.closeDrawer(); });
      });
      this.drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.closeDrawer();
      });
      this.drawer.querySelectorAll('[data-nm-drawer-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.nextElementSibling;
          sub.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () { sub.classList.add('is-active'); });
          var back = sub.querySelector(':scope > [data-nm-drawer-back]');
          if (back) back.focus();
        });
      });
      this.drawer.querySelectorAll('[data-nm-drawer-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.closest('.nm-drawer__sub');
          var opener = sub.previousElementSibling;
          sub.classList.remove('is-active');
          opener.setAttribute('aria-expanded', 'false');
          setTimeout(function () { sub.hidden = true; }, 250);
          opener.focus();
        });
      });
    }

    openDrawer(opener) {
      this.drawerOpener = opener;
      this.setHeightVar();
      this.drawer.hidden = false;
      document.body.classList.add('nm-scroll-lock');
      var self = this;
      requestAnimationFrame(function () {
        self.drawer.classList.add('is-open');
        self.classList.add('is-drawer-open');
        self.drawer.querySelector('.nm-drawer__panel').focus();
      });
      this.querySelectorAll('[data-nm-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }

    closeDrawer() {
      var self = this;
      this.drawer.classList.remove('is-open');
      this.classList.remove('is-drawer-open');
      document.body.classList.remove('nm-scroll-lock');
      this.querySelectorAll('[data-nm-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () {
        self.drawer.hidden = true;
        self.drawer.querySelectorAll('.nm-drawer__sub').forEach(function (s) { s.classList.remove('is-active'); s.hidden = true; });
      }, 300);
      if (this.drawerOpener) this.drawerOpener.focus();
    }
  }

  customElements.define('nm-header', NmHeader);
})();
